/**
 * Returns the locate skill's methodConfig with `textInput` replaced by the
 * step-level override, but ONLY for the `text_prompt` method and ONLY when the
 * override is a non-blank string. Otherwise returns the original config object
 * unchanged (same reference) so callers can cheaply detect "no override".
 *
 * The override is the already-resolved string; callers evaluate any Expression
 * to a string first (see `resolveTextPromptOverride`).
 */
export function applyTextPromptOverride(
  method: string,
  methodConfig: Record<string, unknown>,
  override: string | undefined,
): Record<string, unknown> {
  if (method !== 'text_prompt') return methodConfig;
  if (override == null || override.trim().length === 0) return methodConfig;

  return { ...methodConfig, textInput: override };
}
